import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  root: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' },
};
